<template>
  <main class="pt-24">
    <section id="home">
        <OverXSection />
        <OperacaoPage />
    </section>

    <section id="funcionalidades">
        <MissionVisionValues />
    </section>

    <section id="sobrenos">
         <TeamSection />
    </section>

    <section id="informacoes">
          <DownloadSection />
          <CtaSection />
    </section>

    <section id="experimente">
          <FaqPage />
    </section>
  </main>
</template>

<script>
import OperacaoPage from '@/components/Gestao/OperacaoPage.vue';
import OverXSection from '@/components/Gestao/OverXSection.vue';
import MissionVisionValues from '@/components/Gestao/MissionVisionValues.vue';
import TeamSection from '@/components/Gestao/TeamSection.vue';
import DownloadSection from '@/components/Gestao/DownloadSection.vue';
import FaqPage from '@/components/FAQ/FaqPage.vue';
import CtaSection from '@/components/Gestao/CtaSection.vue';

export default {
  name: "HomePage",
  components: {
    OverXSection,
    OperacaoPage,
    MissionVisionValues,
    TeamSection,
    DownloadSection,
    FaqPage,
    CtaSection
  },
};
</script>